import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const CustomerContext = createContext(null);
export const useCustomer = () => useContext(CustomerContext);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [authOpen, setAuthOpen] = useState(false);
  const [favOpen, setFavOpen] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("lc_customer_token");
    if (!token) { setReady(true); return; }
    api.get("/customer/me")
      .then((r) => { setCustomer(r.data); setFavorites(r.data.favorites || []); })
      .catch(() => localStorage.removeItem("lc_customer_token"))
      .finally(() => setReady(true));
  }, []);

  const persist = (data) => {
    if (data.token) localStorage.setItem("lc_customer_token", data.token);
    setCustomer(data.customer);
    setFavorites(data.customer.favorites || []);
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/customer/register", { name, email, password });
    persist(data);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/customer/login", { email, password });
    if (data.is_admin) {
      localStorage.setItem("lc_admin_token", data.token);
      return data;
    }
    persist(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/customer/logout"); } catch (err) { console.error("Error al cerrar sesión:", err); }
    localStorage.removeItem("lc_customer_token");
    setCustomer(null);
    setFavorites([]);
    toast.success("Sesión cerrada");
  };

  const isFavorite = (bookId) => favorites.includes(bookId);

  const toggleFavorite = async (book) => {
    if (!customer) { setAuthOpen(true); return; }
    try {
      if (isFavorite(book.id)) {
        const { data } = await api.delete(`/customer/favorites/${book.id}`);
        setFavorites(data.favorites);
      } else {
        const { data } = await api.post(`/customer/favorites/${book.id}`);
        setFavorites(data.favorites);
        toast.success(`"${book.title}" guardado en favoritos`);
      }
    } catch {
      toast.error("No se pudo actualizar favoritos");
    }
  };

  return (
    <CustomerContext.Provider value={{
      customer, favorites, ready, authOpen, setAuthOpen, favOpen, setFavOpen,
      register, login, logout, isFavorite, toggleFavorite,
    }}>
      {children}
    </CustomerContext.Provider>
  );
};
